export const ENDPOINTS = {
  getAllFundAccounts: `/api/fund/account/grid`,
  getClients: `/api/corp/clients/fetch/all`,
  saveNew: `/api/tag/save`,
  getAllMakes: `/api/vehicletype/make/list`,
  getALLTags: `/api/tag/all`,
  deletetag: (id) => `/api/tag/delete?id=${id}`,

  getAllCurrencies: `/api/o/currencies`,
  getallContents: `/api/admin/contents`,
  getAllDrivers: (x) =>
    `/api/drivers/data?rows=20${x ? `&name=${x}` : ""}&page=1`,
  getAllCityGroups: `/api/citygroups/cityGroupsList`,
  getAllVendors: `/api/corp/vendors/self/map`,
  getVendorGroup: ` /api/vendorgroups/grid`,
  getCityGroupsByCountry: (country) =>
    `/api/citygroups/grid?country=${country}&rows=1000`,
  getAllTariffTypes: `/api/rates/tariff/type`,
  getAllTariffNames: `/api/tariff/names/all`,
  getAllTransferGroups: `/api/transfer/group/getAll`,
  getAllTimeZones: `/api/o/timezones`,
  getAllCountryLangs: `/api/language/allLang`,
  getAllTaxSlabs: `/api/taxslab/primary/all`,

  getAllExpenseAccountTypes: `/api/expenseaccount/list`,
  getAllArticles: `/api/article/list`,
  getAllCampus: (x) =>
    x ? `/api/campus/${x}/campusMap` : "/api/corp/campuses/map",
  getDesignations: `/ api / designation / all`,
  getRank: `/ api / rank / all`,
};
